import React, { useEffect, useState } from 'react';
import logo from '../blueclan-logo.png';
import './Loader.css';

export default function Loader({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState('loading'); // loading | done

  useEffect(() => {
    /* ramp progress 0→100 over ~2.2s */
    let val = 0;
    const interval = setInterval(() => {
      val += Math.random() * 8 + 4;
      if (val >= 100) {
        val = 100;
        clearInterval(interval);
        setPhase('done');
        setTimeout(onDone, 500);
      }
      setProgress(Math.floor(val));
    }, 80);
    return () => clearInterval(interval);
  }, [onDone]);

  return (
    <div className={`loader-overlay ${phase === 'done' ? 'loader-exit' : ''}`}>
      {/* animated grid */}
      <div className="loader-grid" />

      {/* corner brackets */}
      <div className="loader-bracket tl" />
      <div className="loader-bracket tr" />
      <div className="loader-bracket bl" />
      <div className="loader-bracket br" />

      {/* scan line */}
      <div className="loader-scanline" />

      <div className="loader-body">
        {/* hex ring + logo */}
        <div className="loader-emblem">
          <div className="loader-ring ring-outer" />
          <div className="loader-ring ring-mid" />
          <div className="loader-ring ring-inner" />
          <img src={logo} alt="BlueClan" className="loader-logo" />
        </div>

        {/* clan name */}
        <div className="loader-name">
          <span className="loader-name-blue">BLUE</span>
          <span className="loader-name-clan">CLAN</span>
        </div>
        <div className="loader-tagline">ELITE TECHNOLOGY</div>

        {/* progress bar */}
        <div className="loader-bar-wrap">
          <div className="loader-bar-track">
            <div
              className="loader-bar-fill"
              style={{ width: `${progress}%` }}
            />
            <div
              className="loader-bar-glow"
              style={{ left: `${progress}%` }}
            />
          </div>
          <div className="loader-progress-row">
            <span className="loader-status">
              {progress < 40 ? 'INITIALIZING SYSTEMS' :
               progress < 70 ? 'LOADING ARSENAL' :
               progress < 95 ? 'DEPLOYING CLAN' : 'SYSTEMS READY'}
            </span>
            <span className="loader-pct">{progress}%</span>
          </div>
        </div>

        {/* boot log */}
        <div className="loader-log">
          {progress >= 10  && <div className="log-line">▸ Core systems online</div>}
          {progress >= 35  && <div className="log-line">▸ AI engine initialized</div>}
          {progress >= 60  && <div className="log-line">▸ Web modules loaded</div>}
          {progress >= 85  && <div className="log-line">▸ Connecting to clan...</div>}
          {progress >= 100 && <div className="log-line log-ready">✓ Welcome to BlueClan</div>}
        </div>
      </div>
    </div>
  );
}
